import React from "react";
import { Button, Modal } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Link } from "react-router-dom";

import { Trans } from "@payping/utils/localeUtils";
import { buildUrl } from "@payping/utilities-shared/url";
import { DashboardRoutes } from "@/router";
import { URLS } from "@payping/utilities-shared/consts";
import { useImmerAtom } from "jotai-immer";
import { coreAtom } from "@/core/state/root";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const docUrl = `${URLS.HELP_URL}fa/category/1r4l656/`;
const toProAtom = selectAtom(coreAtom, (val) => val.upgradeUserPanel.toPro);

const DashboardToolsUpgradeUserPlanToProModal: React.FC = () => {
  const [toPro] = useAtom(toProAtom);
  const [, setCoreState] = useImmerAtom(coreAtom);

  const { t } = useAppTranslation();

  const services = {
    invoice: {
      title: t("dashboardTools.upgradeUserPlanToProModal.services.invoice"),
      helpUrl: buildUrl(URLS.HELP_URL, "/fa/faktor-anlainarah-faktor-rsmi/").toString(),
    },
  };

  const handleCloseModal = () => {
    setCoreState((draft) => {
      // eslint-disable-next-line no-param-reassign
      draft.upgradeUserPanel.toPro.service = undefined;
      // eslint-disable-next-line no-param-reassign
      draft.upgradeUserPanel.toPro.showModal = false;
    });
  };

  return (
    <Modal
      open={toPro.showModal}
      onCancel={handleCloseModal}
      centered
      closable
      title={t("dashboardTools.upgradeUserPlanToProModal.title")}
      footer={
        <Link className="tw:w-full" to={DashboardRoutes.user.upgrade.url} onClick={() => handleCloseModal()}>
          <Button className="tw:w-full" type="primary">
            {t("dashboardTools.upgradeUserPlanToProModal.callToAction")}
          </Button>
        </Link>
      }
    >
      <p className="tw:mb-8!">
        {!toPro.service ? (
          ""
        ) : (
          <Trans
            i18nKey={"dashboardTools.upgradeUserPlanToProModal.content"}
            values={{
              serviceName: services[toPro.service].title,
            }}
            components={{
              span: <span />,
              a: <a href={services[toPro.service].helpUrl} target="_blank" rel="noreferrer" />,
              b: <a href={docUrl} target="_blank" rel="noreferrer" />,
            }}
          />
        )}
      </p>
    </Modal>
  );
};

export default DashboardToolsUpgradeUserPlanToProModal;
